module.exports = __webpack_public_path__ + "img/firmware.391013cd.png";